import classNames from 'classnames'
import Icon from 'components/Icon/Icon'
import { SOCIAL } from 'Icon/social'
import { UI } from 'Icon/ui'
import * as React from 'react'
import './Button.scss'

export enum TYPE {
  default = '',
  primary = 'primary',
  ghost = 'ghost',
  angel = 'angel',
  circle = 'circle',
  square = 'square',
  activeSquare = 'activesquare',
  info = 'info',
  flatred = 'flatred',
  lock = 'lock',
  question = 'question',
  inverted = 'inverted',
  inlinetext = 'inlinetext',
  inlineform = 'inlineform',
  plain = 'plain',
  // socials
  youtube = 'youtube',
  twitter = 'twitter',
  instagram = 'instagram',
  facebook = 'facebook',
  pinterest = 'pinterest',
  snapchat = 'snapchat',
  whatsapp = 'whatsapp',
  link = 'link',
}

export enum ButtonColor {
  blue = 'blue',
}

interface ButtonProps {
  disabled?: boolean
  innerRef?: (() => void) | string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  onMouseEnter?: (event: React.MouseEvent<HTMLButtonElement>) => void
  onMouseLeave?: (event: React.MouseEvent<HTMLButtonElement>) => void
  onMouseOver?: (event: React.MouseEvent<HTMLButtonElement>) => void
  onMouseOut?: (event: React.MouseEvent<HTMLButtonElement>) => void
  type?: TYPE
  negative?: boolean
  cutOff?: string
  noShake?: boolean
  className?: string
  submit?: boolean
  verticalAlign?: string
  textTransform?: string
  color?: ButtonColor,
  children?: React.ReactNode | undefined
}

export const Button: React.FC<ButtonProps> = props => {
  const {
    className,
    type,
    negative,
    cutOff,
    noShake,
    verticalAlign,
    innerRef,
    submit,
    onClick,
    textTransform,
    color,
  } = props

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) =>
    onClick && onClick(e)

  const classes = classNames(
    className,
    'srprs-button',
    type && `type-${type}`,
    negative ? `is-negative` : false,
    cutOff ? `cutOff-${cutOff}` : false,
    noShake ? `is-noShake` : false,
    verticalAlign ? `vertical-align-${verticalAlign}` : false,
    textTransform ? `text-transform-${textTransform}` : false,
    color ? `color-${color}` : false,
  )

  return (
    <button
      type={submit ? 'submit' : onClick ? 'button' : undefined}
      disabled={props.disabled}
      className={classes}
      ref={innerRef}
      onClick={handleClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
    >
      {type === TYPE.info ? <Icon icon={UI.info} /> : null}
      {type === TYPE.lock ? <Icon icon={UI.lock} /> : null}
      {type === TYPE.question ? <Icon icon={UI.question} /> : null}
      {type === TYPE.youtube ? <Icon icon={SOCIAL.youtube} /> : null}
      {type === TYPE.twitter ? <Icon icon={SOCIAL.twitter} /> : null}
      {type === TYPE.instagram ? <Icon icon={SOCIAL.instagram} /> : null}
      {type === TYPE.facebook ? <Icon icon={SOCIAL.facebook} /> : null}
      {type === TYPE.pinterest ? <Icon icon={SOCIAL.pinterest} /> : null}
      {type === TYPE.snapchat ? <Icon icon={SOCIAL.snapchat} /> : null}
      {type === TYPE.whatsapp ? <Icon icon={SOCIAL.whatsapp} /> : null}
      {props.children}
    </button>
  )
}

Button.defaultProps = {
  // tag: 'button',
}
